import { createTheme } from '@mui/material';
import { palette } from './palette';

const theme = createTheme({ palette });

export default theme;
